import { db } from "./server/index";

export function addNotice({
	title,
	shortDesc,
	description,
	articles,
	coverURL,
}) {
	const dbRef = db.collection("noticias");

	if (
		title === undefined ||
		shortDesc === undefined ||
		coverURL === undefined ||
		description === undefined
	) {
		console.error("some elements are undefined");
		alert("Preencha todos os campos");
		return;
	}
	dbRef
		.add({ title, shortDesc, articles, description, coverURL })
		.then((doc) => {
			alert("Notícia publicada");
			console.log(doc);
		})
		.catch((err) => console.error(err));
}

export function deleteNotice({ noticeList, onSuccess }) {
	const dbRef = db.collection("noticias");

	const deletions = noticeList.map((id) => dbRef.doc(id).delete());

	Promise.all(deletions)
		.then(() => {
			console.log("Notícias deletadas com sucesso");
			if (onSuccess) onSuccess();
			alert("Noticia(s) deletada(s) com sucesso!");
		})
		.catch((err) => {
			console.error("Erro ao deletar notícias:", err);
		});
}
